<template>
  <div class="folder-select">
    <div class="pb-6">
      <div class="pb-2 text-xs">Selected Folder</div>
      <div class="bg-light-yellow rounded">
          <div class="flex items-start justify-between">
            <!-- <div class="path font-mono text-xl font-bold">{{currentFolder}}</div> -->
            <div class="font-bold text-xl tracking-wide font-mono flex flex-wrap items-end">
              <div v-for="(f, i) in folders">
                  <div
                    class="px-2 py-2 block no-underline cursor-pointer path-seg mr-1"
                    :class="{
                      'last': i + 1 === folders.length,
                      'rounded-l': i === 0
                    }"
                    @click.prevent="changeFolder(f.path)">{{f.seg}}/</div>
              </div>
            </div>


            <!-- <div v-if="currentCount" class="count rounded-full text-xs font-sans font-bold mx-4">{{currentCount}}</div> -->
            
              <div
                class="no-underline text-center text-xs font-bold bg-full-blue text-white py-2 px-4 self-stretch rounded-r cursor-pointer flex items-center"
                @click="selectFolder">
                <div>Go</div>
              </div>
            
          </div>
        
        
      </div>
    </div>
    
    <div v-if="branches && branches.length">
      <div class="pb-2 text-xs">Nested Folders</div>
      <div class="flex flex-wrap">
        <div v-for="b in branches"
          @click="changeFolder(b.path)"
          class="folder text-lg font-mono pb-2 pt-3 px-2 bg-light-yellow rounded-sm font-bold flex flex-col justify-between cursor-pointer">

          <div>{{b.label}}</div>
          <div v-if="b.count" class="text-right text-xs flex justify-end">
            <!-- <div class="count rounded-full font-sans">{{b.count}}</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 import path from 'path';
 import {mapState, mapActions} from 'vuex';

 export default {
   name: 'folder-select',
   props: {
     path: {
       type: String,
       default: '/'
     }
   },

   data () {
     return {
       selectedPath: this.path
     };
   },

   async created () {
     await this.getPaths();
   },

   computed: {
     ...mapState({
       paths: state => state.pathsTree,
       recentPaths: state => state.recentPaths
     }),

     currentFolder () {
       return path.join('/', this.selectedPath);
     },

     branches () {
       const branches = this.getBranch(this.selectedPath, this.paths)
       return branches.list;
     },

     currentCount () {
       const branch = this.getBranch(this.selectedPath, this.paths);
       return branch.count;
     },

     folders () {
       const segs = path.join('/', this.selectedPath, '/')
                        .split('/')
                        .filter((s, i) => i < 1 || !!s)
                        .reduce((acc, s) => {
                          acc.push({
                            // NOTE this takes what has accumulated so far and squashes it together
                            path: path.join.apply(
                              null,
                              ['/'].concat(acc.map(i => i.seg))
                                   .concat(s))
                                      .substr(1),
                            seg: s
                          });
                          return acc;
                        }, []);

       return segs;
     },

   },

   methods: {
     ...mapActions(['getPaths']),

     getBranch (path, tree) {
       const segs = path.split('/').filter(s => !!s);
       let curTree = tree || {list: []};

       for (let i=0; i < segs.length; i++) {
         const seg = segs[i] + '/';

         const match = curTree.list.some(t => {
           if (t && seg === t.label) {
             curTree = t;
             return true;
           }
           return false;
         })

         if (match) {
           continue;
         } else {
           return {};
         }
       }

       return curTree;
     },


     selectFolder () {
       this.$emit('select', this.selectedPath);
     },

     goUpFolder() {
       const p = path.resolve(this.selectedPath, '../');
       this.selectedPath = p;
     },

     changeFolder (folder) {
       this.selectedPath = folder || '/';
     }
   }
 }
</script>

<style scoped>
 .folder {
   width: 30%;
   margin-right: 5%;
   margin-bottom: 40px;
   min-height: 100px;
   word-wrap: anywhere;
 }

 .folder:nth-child(3n+3) {
   margin-right: 0;
 }


 .count {
   background: rgba(0,0,0,.25);
   padding: 3px;
   min-width: 25px;
   text-align: center;
 }
</style>


